export default function createDiscountStoreRequest(formData) {
  return {
    name: formData.name,
    valid_from: formData.validFrom,
    valid_to: formData.validTo,
    is_countdown_enabled: formData.isCountdownEnabled,
    countries: (formData.countries ?? []).map((countryOrId) => countryOrId?.id ?? countryOrId),
    services: formData.services.map((discountService) => ({
      service_id: discountService.id,
      discount_percent: discountService.discountPercent / 100,
    })),
  };
}
